import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { DeleteInsuranceCompanyApi, UpdateInsuranceCompanyApi } from "./insuranceCompanyAction";
import { setHeading } from "../../../accounts/account.actions";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";


const ViewInsuranceCompany = (props) => {
    // const permissions = JSON.parse(window.localStorage.getItem("permissions"))
    // const Checkpermissions = (permissionsType, permissionsName) => {
    //     return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
    // }
    useEffect(() => {
        props.setHeading("Insurance Company List");
    }, []);
    return (
        <>
            {props.isFetchingInsuranceCompany ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <div className="main">
                        <MaterialTable
                            title="Insurance Company List"
                            columns={[
                                { title: 'Company Name', field: 'companyName' },
                                { title: 'Company Location', field: 'location' },
                                { title: 'Email', field: 'email' },
                                { title: 'Phone', field: 'phone' },
                                { title: 'Description', field: 'description' },
                            ]}
                            options={{
                                actionsColumnIndex: -1,
                                exportButton: true,
                                exportAllData: true,
                                paging: true,
                                pageSize: 50,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [50, 100, 150, 200],
                                headerStyle: {
                                    position: 'sticky',
                                    top: 0,
                                    color: '#00BBBB',
                                    fontWeight: '550',
                                    onRowAdd: 'none',
                                },
                            }}
                            data={(query) =>
                                new Promise((resolve, reject) => {
                                    let url = `${baseURL}/insuranceCompany?`;
                                    url += "limit=" + query.pageSize;
                                    url += "&page=" + (query.page);
                                    url += "&search=" + query.search;
                                    fetch(url, {
                                        method: 'GET',
                                        headers: headers,
                                    }).then((response) => response.json()).then((result) => {
                                        resolve({
                                            data: result.data,
                                            page: result.page,
                                            totalCount: result.total_results,
                                        });
                                    });
                                })
                            }
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.UpdateInsuranceCompanyApi(newData, oldData)
                                        }, 600);
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.DeleteInsuranceCompanyApi(oldData._id);
                                        }, 600);
                                    }),
                            }}
                        />
                    </div>
                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        DeleteInsuranceCompanyApi: (companyId) => dispatch(DeleteInsuranceCompanyApi(companyId)),
        UpdateInsuranceCompanyApi: (newData, oldData) => dispatch(UpdateInsuranceCompanyApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    insuranceCompanyDataList: state.InsuranceCompanyReducer.insuranceCompanyDataList,
    isFetchingInsuranceCompany: state.InsuranceCompanyReducer.isFetchingInsuranceCompany,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewInsuranceCompany);